import { sendMessage, Message } from './Communication';

interface AppAction<T> extends Message<T> {
    type: 'appaction';
}

type StatusbarStyles =  'dark' | 'light';

/**
 * This message can be used to change the status bar style.
 */
function statusbarRequest(mode: StatusbarStyles): Promise<void> {
    return sendMessage<AppAction<StatusbarStyles>>(
        {
            type: 'appaction',
            action: 'statusbar_style',
            arguments: mode
        },
        true
    );
}

export const setDarkStatusbar: () => Promise<void> = (): Promise<void> => statusbarRequest('dark');

type FullscreenAction = 'enter' | 'leave';

function fullscreenRequest(mode: 'enter' | 'leave'): Promise<void> {
    return sendMessage<AppAction<FullscreenAction>>(
        {
            type: 'appaction',
            action: 'fullscreen',
            arguments: mode
        },
        true
    );
}

export const enterFullscreen: () => Promise<void> = (): Promise<void> => fullscreenRequest('enter');

type VrModeAction = 'enter' | 'leave' | 'pause' | 'resume';

function arModeRequest(mode: VrModeAction): Promise<void> {
    return sendMessage<AppAction<VrModeAction>>(
        {
            type: 'appaction',
            action: 'ar',
            arguments: mode
        },
        true
    );
}

export const enterArMode: () => Promise<void> = (): Promise<void> => arModeRequest('enter');
export const leaveArMode: () => Promise<void> = (): Promise<void> => arModeRequest('leave');
export const pauseArMode: () => Promise<void> = (): Promise<void> => arModeRequest('pause');
export const resumeArMode: () => Promise<void> = (): Promise<void> => arModeRequest('resume');

interface ArSettings {
    include_camera_frame: boolean;
    show_feature_points: boolean;
}

// Note: the frame is send within the date of the `ar_update` web action
export function requestArCameraFrame(): Promise<void> {
    return sendMessage<AppAction<Partial<ArSettings>>>(
        {
            type: 'appaction',
            action: 'ar_settings',
            arguments: {
                include_camera_frame: true
            }
        },
        true
    );
}

export function showArFeaturePoints(value: boolean): Promise<void> {
    return sendMessage<AppAction<Partial<ArSettings>>>(
        {
            type: 'appaction',
            action: 'ar_settings',
            arguments: {
                show_feature_points: value
            }
        },
        true
    );
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/AppAction.ts